var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBuzzSocialCompressed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 632.672,
    height: 587.563,
    viewBox: "0 0 474.504 440.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M479.398 504.36H350.61l-49.687-86.063c-9.07-15.711-9.07-35.23 0-50.942l4.676-8.101c-2.211-39.684-33.703-71.66-73.176-74.66-3.152 8.523-11.34 14.625-20.945 14.625-12.32 0-22.344-10.028-22.344-22.348 0-12.32 10.023-22.344 22.344-22.344 9.789 0 18.105 6.332 21.12 15.106 40.66 2.672 74.348 31.222 84.739 69.293l24.914-43.156 5.992-10.668c1.696-3.02 3.485-6.258 5.367-9.668 23.793-43.09 63.618-115.207 122.426-115.207 37.438 0 67.89 30.453 67.89 67.89 0 33.653-24.456 61.66-56.472 67.125l52.027 90.117h34.442a7.468 7.468 0 1 1 0 14.934H539.48l-60.082 104.066M350.836 310.77l-2.414 4.18 2.414-4.18m-139.36-41.308c-4.085 0-7.41 3.324-7.41 7.41 0 4.09 3.325 7.414 7.41 7.414a7.42 7.42 0 0 0 7.415-7.414c0-4.086-3.325-7.41-7.414-7.41m264.558-94.3c-49.433 0-86.316 65.788-108.601 106.132h108.601c29.2 0 52.957-23.856 52.957-53.176 0-29.199-23.758-52.957-52.957-52.957",
    style: {
      fill: "#dee1de",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(-166.065 -145.746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.266 209.191a7.445 7.445 0 0 1-5.164-2.07c-2.036-1.95-3.34-3.023-5.7-4.258-3.656-1.91-5.074-6.422-3.164-10.074a7.47 7.47 0 0 1 6.63-4.012 7.38 7.38 0 0 1 3.444.852c3.883 2.023 6.282 3.988 9.114 6.703a7.459 7.459 0 0 1 .23 10.555 7.424 7.424 0 0 1-5.39 2.304M421.66 233.973a7.431 7.431 0 0 1-4.691-1.664 7.46 7.46 0 0 1-1.102-10.5c18.688-23.079 36.613-35.305 54.801-37.38a7.02 7.02 0 0 1 .855-.05c3.715 0 6.973 2.816 7.41 6.625a7.467 7.467 0 0 1-6.574 8.262c-13.91 1.586-29.011 12.332-44.89 31.941a7.447 7.447 0 0 1-5.809 2.766",
    style: {
      fill: "#dee1de",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(-166.065 -145.746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.297 281.746H344.754l-45.379 78.598c-6.41 11.105-6.41 24.898 0 36.008l45.379 78.593h111.543l55.77-96.597-55.77-96.602",
    style: {
      fill: "#ffc217",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(-166.065 -145.746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.297 474.945h-27.45l55.774-96.597-55.773-96.602h27.449l55.77 96.602zm-93.848 0 55.774-96.597-55.774-96.602h31.91l55.774 96.602-55.774 96.597zm-63.074-78.593c-6.41-11.11-6.41-24.903 0-36.008l6.41-11.11h.402c0-.222-.011-.441-.015-.668l30.183-52.277 47.38 82.059-47.38 82.054zM461.559 160.68c29.199 0 52.953 23.757 52.953 52.957 0 29.32-23.754 53.175-52.953 53.175H352.953C375.238 226.47 412.121 160.68 461.56 160.68zM196.996 269.805c-4.086 0-7.41-3.325-7.41-7.414 0-4.086 3.324-7.41 7.41-7.41 4.09 0 7.414 3.324 7.414 7.41a7.42 7.42 0 0 1-7.414 7.414zm362.445 101.074H525l-52.023-90.117c32.011-5.461 56.468-33.473 56.468-67.125 0-37.438-30.453-67.89-67.886-67.89-58.813 0-98.637 72.116-122.43 115.206-1.883 3.41-3.672 6.649-5.367 9.668l-5.992 10.668-24.915 43.156c-10.39-38.07-44.078-66.62-84.738-69.293-3.015-8.773-11.332-15.105-21.12-15.105-12.321 0-22.345 10.023-22.345 22.344 0 12.324 10.024 22.347 22.344 22.347 9.606 0 17.793-6.101 20.945-14.625 39.473 3 70.965 34.977 73.176 74.66l-4.676 8.102c-9.07 15.71-9.07 35.23 0 50.941l49.688 86.067h128.793L525 385.813h34.441a7.464 7.464 0 0 0 7.465-7.465 7.465 7.465 0 0 0-7.465-7.47",
    style: {
      fill: "#3f3f42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(-166.065 -145.746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.922 188.383c2.36 1.234 3.664 2.308 5.7 4.258a7.449 7.449 0 0 0 5.163 2.074c1.965 0 3.93-.774 5.395-2.309a7.463 7.463 0 0 0-.235-10.554c-2.836-2.711-5.23-4.68-9.11-6.704a7.462 7.462 0 0 0-10.073 3.16 7.466 7.466 0 0 0 3.16 10.075M464.453 176.523c-.469-4.097-4.21-7.046-8.265-6.574-18.188 2.074-36.114 14.301-54.801 37.38a7.46 7.46 0 0 0 1.101 10.5 7.426 7.426 0 0 0 4.696 1.663 7.439 7.439 0 0 0 5.804-2.765c15.88-19.61 30.985-30.356 44.89-31.942a7.464 7.464 0 0 0 6.575-8.262M334.89 337.414c-9.34 0-16.91 7.57-16.91 16.91s7.57 16.91 16.91 16.91 16.91-7.57 16.91-16.91-7.57-16.91-16.91-16.91",
    style: {
      fill: "#3f3f42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(-166.065 -145.746)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 164.061,
    y: 585.82,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 72,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      display: "inline",
      fill: "#3b393d",
      fillOpacity: 1,
      strokeWidth: 0.75
    },
    transform: "translate(-166.065 -145.746)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 164.061,
    y: 585.82,
    style: {
      fill: "#3b393d",
      fillOpacity: 1,
      strokeWidth: 0.75
    }
  }, "\uD835\uDC35\uD835\uDCB0\uD835\uDCB5\uD835\uDCB5 \uD835\uDCAE\uD835\uDCAA\uD835\uDC9E\uD835\uDC3C\uD835\uDC9C\uD835\uDC3F")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBuzzSocialCompressed);
export default __webpack_public_path__ + "static/media/logo_buzzSocial_compressed.3bb562be181bebd8c82b4a869194da86.svg";
export { ForwardRef as ReactComponent };